import React from 'react';
import PropTypes from 'prop-types';
import FieldLabel from '../FieldLabel';
import styles from './styles.scss';
import { Box } from '@chakra-ui/react';

class InfoField extends React.PureComponent {
  render() {
    const { children, editMode, label, value, isnLabel } = this.props;
    return (
      <div>
        <FieldLabel label={label} isnLabel={isnLabel} />
        <Choose>
          <When condition={editMode}>{children}</When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{value || '-'}</label>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

InfoField.propTypes = {
  children: PropTypes.node,
  editMode: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  isnLabel: PropTypes.bool,
};

export default InfoField;



// WEBPACK FOOTER //
// src/components/shared/InfoField/index.jsx